import * as RadixRadioGroup from '@radix-ui/react-radio-group';
import { useCallback, useState } from 'react';

import { cn } from '~/lib/cn';

import type { RadioButtonGroupItemType } from './RadioButtonGroupItem';
import { RadioButtonGroupItem } from './RadioButtonGroupItem';

interface RadioButtonGroupProps {
  items: RadioButtonGroupItemType[];
  defaultValue: string;
  className?: string;
  itemClassName?: string;
  itemSelectedClassName?: string;
  onSelect?: (value: string) => void;
}

export function RadioButtonGroup({
  items,
  defaultValue,
  className = '',
  itemClassName = '',
  itemSelectedClassName = '',
  onSelect,
}: RadioButtonGroupProps) {
  const [value, setValue] = useState(defaultValue);

  const onValueChange = useCallback(
    (newValue: string) => {
      setValue(newValue);
      onSelect?.(newValue);
    },
    [onSelect],
  );

  return (
    <RadixRadioGroup.Root
      className={cn('flex flex-col gap-md', className)}
      defaultValue={defaultValue}
      value={value}
      onValueChange={onValueChange}
    >
      {items.map((item) => {
        return (
          <RadioButtonGroupItem
            key={item.value}
            item={item}
            selected={item.value === value}
            className={itemClassName}
            selectedClassName={itemSelectedClassName}
          />
        );
      })}
    </RadixRadioGroup.Root>
  );
}

RadioButtonGroup.displayName = 'RadioButtonGroup';
